export const tabsIds = {
  GRAPH: 0,
  MAP: 1,
}

export const tabsList = [
  { id: tabsIds.GRAPH, label: 'Graph' },
  { id: tabsIds.MAP, label: 'Map' },
]
